import { Input } from "@chakra-ui/react";
import Card from "components/cards/Card";

export const GlobalFilter = ({ filter, setFilter, ...rest }) => {
    return (
        <Input variant='search' placeholder="Suchen..." {...rest} value={filter || ''} onChange={e => setFilter(e.target.value)} />
        
    )
};